/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: ZhangLei
 * @Date: 2020-08-18 13:56:13
 * @LastEditTime: 2020-08-18 13:56:52
 * @LastEditors: ZhangLei
 * @Description:
 * @FilePath: /desktop/src/store/modules/action.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import {
  getActionData,
  createAction,
  editAction,
  getActionInfo,
  deleteAction
} from "@/service/actionService";
const action = {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    /**
     * 获取action列表
     */
    getActionData(store, info) {
      return new Promise((resolve, reject) => {
        getActionData(info)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 创建action
     * @param {*} store
     * @param {*} data
     */
    createAction(store, data) {
      return new Promise((resolve, reject) => {
        createAction(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 获取action详情
     * @param {*} store
     * @param {*} id
     */
    getActionInfo(store, id) {
      return new Promise((resolve, reject) => {
        getActionInfo(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 编辑action
     * @param {*} store
     * @param {*} data
     */
    editAction(store, data) {
      return new Promise((resolve, reject) => {
        editAction(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /**
     * 删除action
     * @param {*} store
     * @param {*} id
     */
    deleteAction(store, id) {
      return new Promise((resolve, reject) => {
        deleteAction(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
export default action;



// WEBPACK FOOTER //
// ./src/store/modules/action.js